import type { GetPreviousDataReturn } from '@/dashboards/shared/optimisation/previousData';

export const UNCATEGORISED_CHANNELS = 'Uncategorised';

type OptimisedChannels = { optimalVariables?: Record<string, unknown> } | null | undefined;

// Widgets enumerate channels from the datasheet's categorised variables, but the optimiser's media
// list comes from the MegaStar "Response Curves" sheet. A medium present only in the optimiser (for
// example a name the backend trimmed on import but the optimiser kept verbatim) would receive budget
// and appear in no row, table or total. Surface it under an explicit group instead of hiding it.
export const withUncategorisedChannels = (
    previous: GetPreviousDataReturn,
    optimizedData: OptimisedChannels,
): GetPreviousDataReturn => {
    const { byCategory, byVariable } = previous.roiCurves.variablesAndCategories;
    const missing = Object.keys(optimizedData?.optimalVariables ?? {}).filter((variable) => !(variable in byVariable));
    if (missing.length === 0) return previous;
    return {
        ...previous,
        roiCurves: {
            ...previous.roiCurves,
            variablesAndCategories: {
                byVariable: { ...byVariable, ...Object.fromEntries(missing.map((variable) => [variable, UNCATEGORISED_CHANNELS])) },
                byCategory: { ...byCategory, [UNCATEGORISED_CHANNELS]: [...(byCategory[UNCATEGORISED_CHANNELS] ?? []), ...missing] },
            },
        },
    };
};
